/// <reference path="../definitions/irep/irep.d.ts" />
/// <reference path="../public/irep.ts" />
/// <reference path="../public/component.ts" />

declare var irep: IREP.IREP;

namespace IREP {
    "use strict";

    export class SWICXExternalManagerRegistration extends Component {
        private $managerSelect: JQuery;
        private $managerSelectRadios: JQuery;
        private $managerSelectGM: JQuery;
        private $managerSelectAU: JQuery;
        private $preferredContact: JQuery;
        private $managerInfo: JQuery;

        private $selectPreferredContactDropdown: JQuery;
        private $selectPreferredContact: JQuery;
        private $selectPreferredContactInput: JQuery;
        private $managerInfoSubmit: JQuery;
        private $preferPhone: JQuery;
        private $preferEmail: JQuery;

        private $swicxManagerInfoInput: JQuery;
        private $authorizedUserInfoSubmit: JQuery;
        private $managerName: JQuery;
        private $managerEmail: JQuery;

        private $swicxDropdownComponent: JQuery;
        private $swicxDropdownItems: JQuery;
        private $swicxDropdownItemSS: JQuery;

        private $nominateSchool: JQuery;
        private $nominateSchoolSelect: JQuery;
        private $swicxSchoolSelect_Ready: JQuery;
        private $swicxSchoolSelect_NotReady: JQuery;
        private $swicxSchoolSelectRadios: JQuery;
        private $swicxSchoolList: JQuery;
        private $swicxSchoolSelect_NotReadyElement: JQuery;
        private $swicxSchoolInput: JQuery;
        private $schoolSubmit: JQuery;
        private $swicSchool1: JQuery;
        private $swicSchool2: JQuery;
        private $swicSchool3: JQuery;
        private $swicSchool4: JQuery;
        private $swicSchool5: JQuery;
        private $swicSchoolFlyer1: JQuery;
        private $swicSchoolFlyer2: JQuery;
        private $swicSchoolFlyer3: JQuery;
        private $swicSchoolFlyer4: JQuery;
        private $swicSchoolFlyer5: JQuery;
        private $storeLocation: JQuery;
        private $stores: JQuery;
        private $thanksfornominating: JQuery;

        private $firstName: JQuery;
        private $lastName: JQuery;
        private $externalEmail: JQuery;
        private $swicxExternalData: JQuery;
        private position: string;
        private auManagerPosition: string;
        private $nominateSchoolSubmit: JQuery;
        private $gmMessage: JQuery;
        private $auMessage: JQuery;
        private submitted: boolean;
        
        constructor(id: string) {
            super(id);

            this.$managerSelect = $(".swicx-manager-select");
            this.$managerSelectRadios = $(".swicx-manager-radio");
            this.$managerSelectGM = $("#swicx-manager-select--gm");
            this.$managerSelectAU = $("#swicx-manager-select--au");
            this.$preferredContact = $("#preferredContact");
            this.$managerInfo = $("#managerInfo");

            this.$selectPreferredContactDropdown = $(
                "#selectPreferredContactDropdown"
            );
            this.$selectPreferredContact = $(".selectPreferredContact");
            this.$selectPreferredContactInput = $(".selectPreferredContactInput");
            this.$managerInfoSubmit = $("#managerInfoSubmit");
            this.$preferPhone = $("#preferPhone");
            this.$preferEmail = $("#preferEmail");

            this.$swicxManagerInfoInput = $(".swicx-manager-info-input");
            this.$authorizedUserInfoSubmit = $("#authorizedUserInfoSubmit");
            this.$managerName = $("#managerName");
            this.$managerEmail = $("#managerEmail");

            this.$swicxDropdownComponent = $(".swicx-dropdown-component");
            this.$swicxDropdownItems = $(".swicx-dropdown--item");
            this.$swicxDropdownItemSS = $(".swicx-dropdown--item-ss");

            this.$swicxSchoolList = $(".swicx-school-list");
            this.$swicxSchoolSelect_NotReadyElement = $(
                ".swicx-school-select--not-ready-element"
            );
            this.$swicxSchoolInput = $(".swicx-school-input");

            //this. = $('.');

            this.$nominateSchool = $("#nominateSchool");
            this.$nominateSchoolSelect = $(".swicx-nominate-school-select");
            this.$swicxSchoolSelect_Ready = $(".swicx-school-select--ready");
            this.$swicxSchoolSelect_NotReady = $(".swicx-school-select--not-ready");
            this.$swicxSchoolSelectRadios = $(".swicx-school-select-radio");
            this.$swicSchool1 = $("#swicSchool1");
            this.$swicSchool2 = $("#swicSchool2");
            this.$swicSchool3 = $("#swicSchool3");
            this.$swicSchool4 = $("#swicSchool4");
            this.$swicSchool5 = $("#swicSchool5");
            this.$schoolSubmit = $("#schoolSubmit");
            this.$thanksfornominating = $("#thanksfornominating");

            this.$storeLocation = $("#storeLocation");
            this.$stores = $("#stores");
            this.$swicSchoolFlyer1 = $("#swicSchoolFlyer1");
            this.$swicSchoolFlyer2 = $("#swicSchoolFlyer2");
            this.$swicSchoolFlyer3 = $("#swicSchoolFlyer3");
            this.$swicSchoolFlyer4 = $("#swicSchoolFlyer4");
            this.$swicSchoolFlyer5 = $("#swicSchoolFlyer5");
            this.$firstName = $("#firstName");
            this.$lastName = $("#lastName");
            this.$externalEmail = $("#externalEmailAddress");

            this.$swicxExternalData = $(".swicx-external-data");

            this.$nominateSchoolSubmit = $('#nominateSchoolSubmit');
            
            this.$gmMessage = $('#gm-message');
            this.$auMessage = $('#au-message');

            this.submitted = false;

            //this.$ = $('#');

            this.$swicxDropdownComponent.on("click", e => this.handleDropdown(e));
            this.$managerSelect.on("click", e => this.showContactForm(e));
            this.$swicxDropdownItemSS.on("click", e => this.selectAndShow(e));

            this.$selectPreferredContactInput.on("change", e =>
                this.enableSubmit(e, this.$managerInfoSubmit)
            );
            this.$swicxManagerInfoInput.on("change", e =>
                this.enableSubmit(e, this.$authorizedUserInfoSubmit)
            );

            this.$managerInfoSubmit.on("click", e => this.submitManagerInfo(e));
            this.$authorizedUserInfoSubmit.on("click", e =>
                this.submitManagerInfo(e)
            );
            this.$schoolSubmit.on("click", e => this.submitSchoolInfo(e));

            this.$nominateSchoolSelect.on("click", e => this.handleNominateRadio(e));

            this.$swicxSchoolInput.on("change", e =>
                this.enableSubmit(e, this.$schoolSubmit)
            );

            this.$storeLocation.on("change", e => {
                this.GetStores();
            });

            this.GetStoreChains();

            this.$swicxExternalData.on("focusout", e => {
                if (this.submitted) {
                    this.validateRegistration('managerInfoSubmit');
                    this.validateRegistration('authorizedUserInfoSubmit');
                }
                this.enableSubmit(e, this.$managerInfoSubmit);
                this.enableSubmit(e, this.$authorizedUserInfoSubmit);
            });
            this.$swicxExternalData.on("change", e => {
                this.enableSubmit(e, this.$managerInfoSubmit);
                this.enableSubmit(e, this.$authorizedUserInfoSubmit);
            });
        }

        private handleDropdown(e) {
            let $items = $(e.currentTarget).find(".swicx-dropdown--item");

            if ($(e.currentTarget).hasClass("open")) {

                let text = $(e.currentTarget).find(".swicx-dropdown--default").html();
                
                $(e.currentTarget).removeClass("open");
                $items.addClass("hidden");

                if (e.target.classList.contains('swicx-dropdown--arrow-wrapper') || e.target.classList.contains('swicx-dropdown--arrow-down') || e.target.classList.contains('swicx-dropdown--arrow-up')) {

                    $(e.currentTarget)
                        .find(".swicx-dropdown--default")
                        .html(text);
                }
                else {
                    $(e.currentTarget)
                        .find(".swicx-dropdown--default")
                        .html($(e.target).html());
                }

                if ($(e.currentTarget).attr("id") == "selectManagerTitle") {
                    this.enableSubmit(e, this.$authorizedUserInfoSubmit);
                }
            } else {
                $(e.currentTarget).addClass("open");
                $items.removeClass("hidden");
            }
            //nice to have - this.flipArrow(e);
        }

        private selectAndShow(e) {
            let targetId = $(e.currentTarget)
                .attr("id")
                .replace("select-", "");
            let $showDiv = $("#" + targetId);
            let $siblings = $(e.currentTarget)
                .parents(".swicx-dropdown-component")
                .find(".swicx-dropdown--item");

            $siblings.each((idx, sibling) => {
                let id = $(sibling)
                    .attr("id")
                    .replace("select-", "");
                $("#" + id).addClass("hidden");
            });

            $showDiv.removeClass("hidden");

            //disable/enable btn if necessary
            let $btn = $(e.currentTarget)
                .parents(".swicx-dropdown-component")
                .parent("div")
                .siblings(".swicx-btn");
            if ($showDiv.val() == "") {
                $btn.addClass("swicx-btn--disabled");
            } else {
                $btn.removeClass("swicx-btn--disabled");
            }
        }

        private showContactForm(e) {
            this.$managerSelectRadios.removeClass("swicx-radio--selected");
            this.$swicxDropdownItems.addClass("hidden");
            this.$swicxDropdownComponent.removeClass("open");

            if (e.currentTarget == this.$managerSelectGM.get(0)) {
                this.$managerSelectGM
                    .find(".swicx-manager-radio")
                    .addClass("swicx-radio--selected");
                this.$preferredContact.removeClass("hidden");
                this.$managerInfo.addClass("hidden");
                this.position = "GM";
            }
            if (e.currentTarget == this.$managerSelectAU.get(0)) {
                this.$managerSelectAU
                    .find(".swicx-manager-radio")
                    .addClass("swicx-radio--selected");
                this.$managerInfo.removeClass("hidden");
                this.$preferredContact.addClass("hidden");
                this.position = "AU";
            }
        }

        private enableSubmit(e, $btn) {

            let buttonId = $btn.attr("id");
            if ($btn.attr("id") == "managerInfoSubmit" || $btn.attr("id") == "authorizedUserInfoSubmit") {

                if (this.checkAllFields(buttonId)) {
                    $btn.removeClass("swicx-btn--disabled");
                } else {
                    $btn.addClass("swicx-btn--disabled");
                }
            }

            if ($btn.attr("id") == "schoolSubmit") {
                if (
                    this.$swicSchool1.val() != "" ||
                    this.$swicSchool2.val() != "" ||
                    this.$swicSchool3.val() != "" ||
                    this.$swicSchool4.val() != "" ||
                    this.$swicSchool5.val() != ""
                ) {
                    $btn.removeClass("swicx-btn--disabled");
                } else {
                    $btn.addClass("swicx-btn--disabled");
                }
            }
        }

        private submitManagerInfo(e) {
            this.submitted = true;
            let buttonId = $(e.currentTarget).attr("id");

            if (!this.checkAllFields(buttonId)) {
                $(e.currentTarget).addClass('swicx-btn--disabled ltGreen_ dKNavy');
                return false;
            }

            if (this.validateRegistration(buttonId) == true) {

                if (buttonId == "managerInfoSubmit") {
                    this.$managerInfoSubmit.hide();
                    this.$managerSelect.unbind("click");
                    this.$selectPreferredContactDropdown.unbind("click");
                    this.$swicxDropdownComponent.unbind("click");
                }


                if (buttonId == "authorizedUserInfoSubmit") {
                    this.$authorizedUserInfoSubmit.hide();
                    this.$managerSelect.unbind("click");
                    this.$selectPreferredContactDropdown.unbind("click");
                    this.$swicxDropdownComponent.unbind("click");
                    this.$swicxManagerInfoInput.unbind("click");
                }

                this.submitManagerData();

                //if ($("#positionGM:checked").length > 0) {
                //    self.disableForGM();
                //    $("#thanksGM").show();
                //    $(".thanksGM").show();
                //    $(".removeMe").hide();
                //} else if ($("#positionDM:checked").length > 0) {
                //    self.disableForDM();
                //    $("#thanksDM").show();
                //    $(".thanksDM").show();
                //    $(".removeMe").hide();
                //} else if ($("#positionAU:checked").length > 0) {
                //    self.disableForAU();
                //    $(".thanksAU").show();
                //    $(".removeMe").hide();

                //}
            }
        }

        private validateRegistration = function (buttonId) {
            var phoneno = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
            var errors = 0;
            var rg = /\w+([-+.'\w]+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/gi;


            //Validate external data
            if (this.$externalEmail.val().match(rg) == null) {
                errors += 1;
                this.$externalEmail[0].style.border = "solid 1px red";
            } else {
                this.$externalEmail[0].style.border = "";
            }

            if (this.$firstName.val() == "") {
                errors += 1;
                this.$firstName[0].style.border = "solid 1px red";
            } else {
                this.$firstName[0].style.border = "";
            }

            if (this.$lastName.val() == "") {
                errors += 1;
                this.$lastName[0].style.border = "solid 1px red";
            } else {
                this.$lastName[0].style.border = "";
            }

            if (this.$storeLocation.find("option:selected").val() == "" ||
                this.$storeLocation.find("option:selected").val() == undefined ||
                this.$storeLocation.find("option:selected").val() == 0 ||
                this.$storeLocation.find("option:selected").html() == "Please select" ||
                this.$storeLocation.find("option:selected").html() == "") {

                errors += 1;
                this.$storeLocation[0].style.border = "solid 1px red";
            } else {
                this.$storeLocation[0].style.border = "";
            }

            if (this.$stores.find("option:selected").val() == "" ||
                this.$stores.find("option:selected").val() == undefined ||
                this.$stores.find("option:selected").val() == 0 ||
                this.$stores.find("option:selected").html() == "Please select" ||
                this.$stores.find("option:selected").html() == "") {

                errors += 1;
                this.$stores[0].style.border = "solid 1px red";
            } else {
                this.$stores[0].style.border = "";
            }
                
            //Store/General Manager
            if (buttonId == "managerInfoSubmit") {
                if (
                    !this.$preferEmail.hasClass("hidden") &&
                    this.$preferEmail.val().match(rg) == null
                ) {
                    errors += 1;
                    this.$preferEmail[0].style.border = "solid 1px red";
                } else {
                    this.$preferEmail[0].style.border = "";
                }

                if (
                    !this.$preferPhone.hasClass("hidden") &&
                    this.$preferPhone.val().match(phoneno) == null
                ) {
                    errors += 1;
                    this.$preferPhone[0].style.border = "solid 1px red";
                } else {
                    this.$preferPhone[0].style.border = "";
                }
            }

            //Authorized User
            if (buttonId == "authorizedUserInfoSubmit") {
                if (
                    !this.$managerEmail.hasClass("hidden") &&
                    this.$managerEmail.val().match(rg) == null
                ) {
                    errors += 1;
                    this.$managerEmail[0].style.border = "solid 1px red";
                } else {
                    this.$managerEmail[0].style.border = "";
                }
            }


            //if ($("#positionGM:checked").length > 0) {
            //    if ($selected == "") {
            //        errors += 1;

            //        document.getElementById("selectContact").style.border = "solid 1px red";
            //    }
            //    document.getElementById("errorPosition").style.display = "none";
            //} else if ($("#positionAU:checked").length > 0) {
            //    if (document.getElementById("managerEmail").value.match(rg) == null) {
            //        errors += 1;
            //        document.getElementById("managerEmail").style.border = "solid 1px red";
            //    } else {
            //        document.getElementById("managerEmail").style.border = "";
            //    }

            //    if (document.getElementById("managerName").value == "") {
            //        errors += 1;
            //        document.getElementById("managerName").style.border = "solid 1px red";
            //    } else {
            //        document.getElementById("managerName").style.border = "";
            //    }
            //    if (document.getElementById("auManagerPosition").value == 0) {
            //        errors += 1;
            //        document.getElementById("auManagerPosition").style.border = "solid 1px red";
            //    } else {
            //        document.getElementById("auManagerPosition").style.border = "";
            //    }
            //    document.getElementById("errorPosition").style.display = "none";
            //} else if ($("#positionDM:checked").length > 0) {
            //    if ($selected == "") {
            //        errors += 1;

            //        document.getElementById("selectContact").style.border = "solid 1px red";
            //    }
            //    document.getElementById("errorPosition").style.display = "none";
            //} else {
            //    errors += 1;
            //    document.getElementById("errorPosition").style.display = "block";
            //}

            //if (($selected == "phone") && !($("#preferPhone").val().match(phoneno))) {
            //    errors += 1;

            //    document.getElementById("preferPhone").style.border = "solid 1px red";
            //} else if (($selected == "e-mail") && (!validateEmail($("#preferEmail").val()))) {
            //    errors += 1;
            //    document.getElementById("preferEmail").style.border = "solid 1px red";
            //}

            if (errors > 0) {
                return false;
            } else {
                return true;
            }
        };

        private submitManagerData = function () {

            var self = this;

            let managerName = this.position == 'GM' ? this.$firstName.val() + ' ' + this.$lastName.val() : this.$managerName.val();
            let managerEmail = this.position == 'GM' ? this.$externalEmail.val() : this.$managerEmail.val();
            let preferEmail = this.$preferEmail.val();
            let preferPhone = this.$preferPhone.val();

            irep
                .callApi({
                    url: "/swicX/externalmanagerinfo",
                    type: "POST",
                    data: {
                        storeid: self.$stores.find("option:selected").val(),
                        firstName: self.$firstName.val(), // document.getElementById("firstname").value,
                        lastName: self.$lastName.val(), // document.getElementById("lastname").value,
                        email: self.$externalEmail.val(), // document.getElementById("email").value,
                        position: self.position,
                        managerName: managerName,
                        managerEmail: managerEmail,
                        preferemail: preferEmail,
                        preferphone: preferPhone,
                        auManagerPosition: self.auManagerPosition
                    },
                    anonymous: true
                })
                .done(d => {
                    //TODO:  Move show school nomination here and make it work;
                });

            self.$nominateSchool.removeClass("hidden");
        };

        private handleNominateRadio(e) {
            this.$swicxSchoolSelectRadios.removeClass("swicx-radio--selected");
            this.$schoolSubmit.removeClass("hidden");

            if (e.currentTarget == this.$swicxSchoolSelect_Ready.get(0)) {
                this.$swicxSchoolSelect_Ready
                    .find(".swicx-school-select-radio")
                    .addClass("swicx-radio--selected");
                this.$swicxSchoolList.removeClass("hidden");
                this.$schoolSubmit.addClass("swicx-btn--disabled");
            }
            if (e.currentTarget == this.$swicxSchoolSelect_NotReady.get(0)) {
                this.$swicxSchoolSelect_NotReady
                    .find(".swicx-school-select-radio")
                    .addClass("swicx-radio--selected");
                this.$swicxSchoolList.addClass("hidden");
                this.$schoolSubmit.removeClass("swicx-btn--disabled");
            }
        }

        private submitSchoolInfo(e) {
            this.$nominateSchoolSelect.unbind("click");

            if (this.$swicxSchoolSelect_NotReady.find(".swicx-school-select-radio").hasClass("swicx-radio--selected")) {
                this.$swicxSchoolSelect_NotReadyElement.removeClass("hidden");
                this.$schoolSubmit.addClass("hidden");
                this.UpdateNominateLater(true, this.$externalEmail.val());
            }
            else {

                let externalNominator = this.$externalEmail.val();

                let storeId = this.$stores.find("option:selected").val();

                let school1 = this.$swicSchool1.val();
                let school2 = this.$swicSchool2.val();
                let school3 = this.$swicSchool3.val();
                let school4 = this.$swicSchool4.val();
                let school5 = this.$swicSchool5.val();

                let gotFlyer1 = this.$swicSchoolFlyer1.is(":checked");
                let gotFlyer2 = this.$swicSchoolFlyer2.is(":checked");
                let gotFlyer3 = this.$swicSchoolFlyer3.is(":checked");
                let gotFlyer4 = this.$swicSchoolFlyer4.is(":checked");
                let gotFlyer5 = this.$swicSchoolFlyer5.is(":checked");

                if (school1 != "") {
                    irep
                        .callApi({
                            url: "/swicX/nominateSchool",
                            type: "POST",
                            data: {
                                Nomination: {
                                    StoreId: storeId,
                                    School: school1,
                                    ExternalNominator: externalNominator,
                                    GotFlyer: gotFlyer1
                                }
                            }
                        })
                        .done(() => {
                            this.$thanksfornominating.removeClass("hidden");
                            this.$nominateSchool.addClass("hidden");
                        });
                }
                if (school2 != "") {
                    irep
                        .callApi({
                            url: "/swicX/nominateSchool",
                            type: "POST",
                            data: {
                                Nomination: {
                                    StoreId: storeId,
                                    School: school2,
                                    ExternalNominator: externalNominator,
                                    GotFlyer: gotFlyer1
                                }
                            }
                        })
                        .done(() => {
                            this.$thanksfornominating.removeClass("hidden");
                            this.$nominateSchool.addClass("hidden");
                        });
                }
                if (school3 != "") {
                    irep
                        .callApi({
                            url: "/swicX/nominateSchool",
                            type: "POST",
                            data: {
                                Nomination: {
                                    StoreId: storeId,
                                    School: school3,
                                    ExternalNominator: externalNominator,
                                    GotFlyer: gotFlyer1
                                }
                            }
                        })
                        .done(() => {
                            this.$thanksfornominating.removeClass("hidden");
                            this.$nominateSchool.addClass("hidden");
                        });
                }
                if (school4 != "") {
                    irep
                        .callApi({
                            url: "/swicX/nominateSchool",
                            type: "POST",
                            data: {
                                Nomination: {
                                    StoreId: storeId,
                                    School: school4,
                                    ExternalNominator: externalNominator,
                                    GotFlyer: gotFlyer1
                                }
                            }
                        })
                        .done(() => {
                            this.$thanksfornominating.removeClass("hidden");
                            this.$nominateSchool.addClass("hidden");
                        });
                }
                if (school5 != "") {
                    irep
                        .callApi({
                            url: "/swicX/nominateSchool",
                            type: "POST",
                            data: {
                                Nomination: {
                                    StoreId: storeId,
                                    School: school5,
                                    ExternalNominator: externalNominator,
                                    GotFlyer: gotFlyer1
                                }
                            }
                        })
                        .done(() => {
                            this.$thanksfornominating.removeClass("hidden");
                            this.$nominateSchool.addClass("hidden");
                        });
                }

                this.$thanksfornominating.removeClass("hidden");
                this.$nominateSchool.addClass("hidden");
                this.UpdateNominateLater(false, this.$externalEmail.val());

                if (this.position == 'GM') {
                    this.$gmMessage.removeClass("hidden");
                }
                if (this.position == 'AU') {
                    this.$auMessage.removeClass("hidden");
                }

            }
        }

        private GetStoreChains() {
            let self = this;

            irep
                .callApi({
                    url: "managerprofile/storechains",
                    type: "GET",
                    data: {},
                    anonymous: true
                })
                .done(function (d) {
                    self.$storeLocation.append(
                        "<option value='0'>Please select</option>"
                    );
                    $.each(d.chains, function (index, item) {
                        self.$storeLocation.append(
                            $("<option></option>")
                                .text(item.name)
                                .val(item.id)
                        );
                    });
                });
        }

        private GetStores() {
            let self = this;

            irep
                .callApi({
                    url: "managerprofile/stores",
                    type: "GET",
                    data: { StoreChainId: self.$storeLocation.val() }
                })
                .done(function (d) {
                    self.$stores.show();
                    self.$stores.find("option").remove(); // Remove all <option> child tags.

                    self.$stores.append("<option value='0'>Please select</option>");
                    $.each(d.stores, function (index, item) {
                        self.$stores.append(
                            $("<option></option>")
                                .text(item.name)
                                .val(item.id)
                        );
                    });
                });
        }

        private UpdateNominateLater(willNominate, email) {
            irep
                .callApi({
                    url: "/swicX/updatenominatelater",
                    type: "POST",
                    data: { WillNominateLater: willNominate, Email: email }
                })
                .done();
        }

        private isExternalDataCompleted(buttonId) {
            if (
                this.$firstName.val() != "" &&
                this.$lastName.val() != "" &&
                this.$externalEmail.val() != "" &&
                this.$stores.find("option:selected").val() != "" &&
                this.$stores.find("option:selected").val() != undefined &&
                this.$stores.find("option:selected").val() != 0 &&
                this.$stores.find("option:selected").html() != "Please select" &&
                this.$stores.find("option:selected").html() != ""
            ) {
                if (this.submitted) {
                    this.validateRegistration(buttonId)
                }
                return true;
            }
            return false;
        }

        private checkAllFields(buttonId) {
            if (buttonId == 'managerInfoSubmit') {
                let preferPhoneValue = this.$preferPhone.val();
                let preferEmailValue = this.$preferEmail.val();

                let dropdownValue = this.$selectPreferredContactDropdown.find('.swicx-dropdown--default').html();

                let GMPass = false;
                if (dropdownValue == 'Phone Number' && preferPhoneValue != "") {
                    GMPass = true;
                }

                if (dropdownValue == 'E-mail' && preferEmailValue != "") {
                    GMPass = true;
                }

                if (GMPass && this.isExternalDataCompleted(buttonId)) {
                    return true;
                }
            }

            if (buttonId == "authorizedUserInfoSubmit") {
                let $dropdown = $("#managerInfo #selectManagerTitle");
                let title = $("#selectManagerTitle .swicx-dropdown--default").html();

                let self = this;
                switch (title) {
                    case "General Manager":
                        self.auManagerPosition = "242";
                        break;
                    case "Manager":
                        self.auManagerPosition = "285";
                        break;
                    case "Supervisor":
                        self.auManagerPosition = "286";
                        break;
                    default:
                        self.auManagerPosition = "0";
                        break;
                }

                if (
                    title != "Please select" &&
                    this.$managerName.val() !== "" &&
                    this.$managerEmail.val() !== "" &&
                    this.isExternalDataCompleted(buttonId)
                ) {
                    if (this.submitted) {
                        this.validateRegistration(buttonId)
                    }
                    return true;
                }
            }
            return false;
        }
    }
}
